export default "__VITE_ASSET__D$104VyY__"